import React from 'react';

export default function ActionCard({ 
    className, 
    title, 
    children, 
    buttons, 
    icon, 
    onClick, 
    disabled = false, 
    tooltip = '' 
}: { 
    className?: string, 
    title: string, 
    children?: React.ReactNode, 
    buttons?: React.ReactNode, 
    icon?: React.ReactNode, 
    onClick?: () => void,
    disabled?: boolean,
    tooltip?: string
}) {
    const handleClick = () => {
        if (!disabled && onClick) {
            onClick();
        }
    };

    return (
        <div 
            className={`card bg-base-100 shadow-sm min-h-full min-w-min ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:cursor-pointer hover:shadow-xl'} ${className||''}`}
            title={tooltip}
        >
            <div className="card-body clickable" onClick={handleClick}>
                {icon && <div className="card-icon">{icon}</div>}
                <p className="card-title text-sm">{title}</p>
                {buttons && 
                <div className="card-actions justify-end">
                    {buttons}
                </div>
                }
            </div>
        </div>
    )
}